import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'tristate',
    template: require('./tristate.dropdown.component.html')
})

export class TristateComponent {

    boolValues: Array<any>;

    inputValue: boolean;

    @Input()
    get value() {
        return this.inputValue;
    }

    set value(val) {
        
        this.inputValue = val;
        this.valueChange.emit(this.inputValue);
    }


    @Output() valueChange: EventEmitter<boolean> = new EventEmitter();

    constructor() {
        this.boolValues = new Array<any>();

        this.boolValues.push({ value: null, display: "Don't know" });
        this.boolValues.push({ value: true, display: "Yes" });
        this.boolValues.push({ value: false, display: "No" });
    }
}




// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/tristatedropdown/tristate.dropdown.component.ts